/**
 * MobileNavDrawer — menu de navigation en tiroir pour les écrans étroits
 * (< 600 dp, portrait) : le bouton ☰ ouvre la barre latérale habituelle
 * (AppSidebar, mêmes entrées et permissions) dans une feuille à gauche.
 * Le tiroir se referme à chaque changement de page.
 */
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import AppSidebar from '@/components/AppSidebar';
import { Sheet, SheetContent, SheetDescription, SheetTitle } from '@/components/ui/sheet';
import { useFeatureToggles } from '@/hooks/useFeatureToggles';
import { cn } from '@/lib/utils';

export function MobileNavDrawer() {
  const [open, setOpen] = useState(false);
  const { pathname, search } = useLocation();
  const { isFeatureEnabled } = useFeatureToggles();
  const touch = isFeatureEnabled('menu_tactile');
  useEffect(() => setOpen(false), [pathname, search]);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Ouvrir le menu"
        data-testid="mobile-nav-open"
        className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl active:bg-secondary"
      >
        <Menu className="h-6 w-6" />
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent
          side="left"
          className={cn(
            'p-0 [&>aside]:w-full',
            touch
              ? 'w-[300px] max-w-[88vw] [&>button:last-child]:right-1 [&>button:last-child]:top-1 [&>button:last-child]:z-[60] [&>button:last-child]:flex [&>button:last-child]:h-12 [&>button:last-child]:w-12 [&>button:last-child]:items-center [&>button:last-child]:justify-center'
              : 'w-[280px] max-w-[85vw] [&>button:last-child]:hidden',
          )}
          data-testid="mobile-nav-drawer"
        >
          <SheetTitle className="sr-only">Menu</SheetTitle>
          <SheetDescription className="sr-only">Navigation VisionPOS</SheetDescription>
          <AppSidebar touch={touch} />
        </SheetContent>
      </Sheet>
    </>
  );
}
